import { figmaColors } from '@doltech/ui/lib/figma/colors';
import { colorsV2 } from '@doltech/ui/lib/figma/colors-v2';
import { Box } from '@doltech/ui/lib/figma/Common/Box';
import { ImageAlignEnum } from '@doltech/ui/lib/figma/DolEditor/components/ImageResizableAlignable/ImageAlignEnum';
import { ImageResizableAlignable } from '@doltech/ui/lib/figma/DolEditor/components/ImageResizableAlignable/ImageResizableAlignable';
import { InputBlank } from '@doltech/ui/lib/figma/DolEditor/components/InputBlank/InputBlank';
import { useDeviceDetect } from '@doltech/ui/lib/hooks/useDeviceQuery.hook';
import { TestModeEnum } from '@doltech/utils/lib/constants';
import cl from 'classnames';
import { observer } from 'mobx-react-lite';
import { getSnapshot } from 'mobx-state-tree';
import * as React from 'react';
import { useEffectOnce } from 'react-use';
import styled from 'styled-components';

import { defaultSlateValue } from '../question-data-model/SlateObj/slate-editor.store';
import { DoTestDiagramLabelCompletionQuestionInstance } from '../student-do-test/model/Question/do-test-diagram-label-completion.store';
import { useTestSubmissionStore } from '../student-do-test/model/test-submissions.hook';

const Main = styled(Box)`
  position: relative;
  .ant-spin-nested-loading {
    width: auto;
  }
  .title {
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 20px;
    color: ${figmaColors.text1};
  }
  .sub-title {
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 20px;
    display: flex;
    align-items: center;

    color: ${figmaColors.neutral3};
  }
  .diagram-content {
    margin-top: 12px;
  }
  .wrapper-blank-editor {
    display: flex;
    flex-direction: row;
    width: 100%;

    .input-blank {
      flex: 1;
      width: 100%;
      .dol-editor {
        width: 100%;
        .editor-editable-plugins {
          background-color: ${colorsV2.white100};
          border: none;
          line-height: 20px;
        }
        .editor-content-wrapper {
          margin-top: 4px;
        }
      }
    }

    &.${ImageAlignEnum.ALIGN_CENTER} {
      flex-direction: column;
      align-items: center;
    }

    &.${ImageAlignEnum.ALIGN_RIGHT} {
      flex-direction: row-reverse;
    }
  }
`;
export interface DiagramLabelCompletionProps extends React.HTMLAttributes<HTMLDivElement> {
  data: DoTestDiagramLabelCompletionQuestionInstance;
  isPdfContent?: boolean;
  mode?: TestModeEnum;
}

export const DiagramLabelCompletionAnswer = observer((props: DiagramLabelCompletionProps) => {
  const constraintsRef = React.useRef(null);

  const { data, isPdfContent, mode = TestModeEnum.DO_TEST, ...rest } = props;
  const { no, onAnswerQuestion, nodeImage, nodeBlanks, userAnswers, initUserAnswers } = data;
  const { isMobile, isTablet } = useDeviceDetect();
  const imageAlign =
    (isMobile || isTablet) && !isPdfContent ? ImageAlignEnum.ALIGN_CENTER : nodeImage?.align;
  const store = useTestSubmissionStore();
  useEffectOnce(() => {
    initUserAnswers();
  });

  return (
    <div className="dol-question">
      <Main ref={constraintsRef} {...rest}>
        <div className={cl('wrapper-blank-editor', { [imageAlign]: true })}>
          <ImageResizableAlignable
            spots={nodeImage.spots.map((spot) => {
              const text = no + Number(spot.text) - 1;
              return {
                ...spot,
                text,
              };
            })}
            imageWidth={nodeImage?.width}
            currentAlignment={isMobile && !isPdfContent ? ImageAlignEnum.ALIGN_CENTER : imageAlign}
            url={nodeImage?.image?.url}
            readOnly
          />
          <InputBlank
            initialValue={nodeBlanks?.[0]?.getEditorValue() || defaultSlateValue}
            initBlanks={nodeBlanks?.[0]?.blanks || []}
            userAnswers={getSnapshot(userAnswers)}
            withToolbar={undefined}
            questionNo={no}
            mode={mode}
            readOnly
            onUserAnswerChange={(...args) => {
              if (store.preventUserAction()) return;
              onAnswerQuestion(...args);
            }}
          />
        </div>
      </Main>
    </div>
  );
});
